/**
 * Invokes `fn` and returns its result.
 *
 * Alternative to IIFE. Emulates do-expression.
 */
export function invoke<T>(fn: () => T): T {
  return fn();
}
